import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'room_guid': 'String!',
	'timeslot_guid': '[String]!',
};

export default gql(`
	mutation room_to_timeslot( ${ HelperGraphql.createFields( fields ) } ) {
	    room_to_timeslot( ${ HelperGraphql.createVariables( fields ) } ) {
	        room {
	            guid
	        }
	        
	        timeslot {
	            guid
	        }
	    }
	}
`);

